// Fail-fast env validation: missing VITE_* vars throw at startup rather than
// silently rendering broken UI.

const REQUIRED_VARS = [
  'VITE_AUTH_BASE_URL',
  'VITE_COGNITO_USER_POOL_ID',
  'VITE_COGNITO_CLIENT_ID',
  'VITE_COGNITO_DOMAIN',
] as const;

type RequiredVar = (typeof REQUIRED_VARS)[number];

interface Env {
  authBaseUrl: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  cognitoDomain: string;
}

export function getEnv(): Env {
  const missing: string[] = [];
  for (const key of REQUIRED_VARS) {
    if (!import.meta.env[key as RequiredVar]) {
      missing.push(key);
    }
  }
  if (missing.length > 0) {
    throw new Error(`Missing required env vars: ${missing.join(', ')}`);
  }
  return {
    authBaseUrl: import.meta.env.VITE_AUTH_BASE_URL as string,
    cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
    cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
    cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN as string,
  };
}
